import { View, Text, ScrollView, Pressable, StyleSheet, Linking } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useRouter } from 'expo-router'
import { ArrowLeft } from 'lucide-react-native'
import { colors, spacing, borderRadius, typography } from '../src/theme'
import ContentContainer from '../src/components/ContentContainer'

const SECTIONS = [
  {
    title: '1. Om ForbrugerAgenten',
    body: 'ForbrugerAgenten er en dansk tjeneste, der hjælper forbrugere med at finde bedre aftaler på strøm, mobil og bredbånd. Vi indhenter tilbud fra selskaber på dine vegne og præsenterer dem samlet, så du kan sammenligne og spare penge.',
  },
  {
    title: '2. Brug af tjenesten',
    body: 'For at bruge ForbrugerAgenten skal du logge ind med MitID. Ved login verificerer vi din identitet, og du accepterer disse vilkår. Tjenesten er gratis for forbrugere.',
  },
  {
    title: '3. Fuldmagt',
    body: 'Når du starter en "jagt" (tilbudsforespørgsel), giver du ForbrugerAgenten fuldmagt til at kontakte selskaber på dine vegne. Fuldmagten dækker kun indhentning af tilbud — vi skifter aldrig leverandør uden dit eksplicitte samtykke. Du kan til enhver tid tilbagekalde fuldmagten via dine indstillinger.',
  },
  {
    title: '4. Agent Email',
    body: 'Vi opretter en dedikeret email-adresse (agent email) på dine vegne til kommunikation med selskaber. Alle beskeder sendt til denne adresse vises i din indbakke på platformen. Du kan til enhver tid slette din konto, hvorved agent emailen deaktiveres.',
  },
  {
    title: '5. Tilbud og anbefalinger',
    body: 'Tilbud præsenteret via ForbrugerAgenten er indhentet direkte fra selskaberne. Vi bestræber os på at præsentere korrekte priser, men det endelige tilbud afhænger altid af selskabets vilkår. ForbrugerAgenten er ikke ansvarlig for selskabernes priser, leverance eller kundeservice.',
  },
  {
    title: '6. AI-rådgivning',
    body: 'Vores AI-chat giver generel rådgivning baseret på dine data. AI kan lave fejl — tjek altid vigtige oplysninger. AI-rådgivningen udgør ikke professionel finansiel eller juridisk rådgivning.',
  },
  {
    title: '7. Sletning af konto',
    body: 'Du kan til enhver tid slette din konto via Indstillinger. Ved sletning fjernes alle dine persondata, aftaler, jagter og beskeder permanent. Denne handling kan ikke fortrydes.',
  },
  {
    title: '8. Ændringer i vilkår',
    body: 'Vi kan opdatere disse vilkår. Ved væsentlige ændringer giver vi besked via din indbakke på platformen. Fortsat brug af tjenesten efter ændringer udgør accept af de opdaterede vilkår.',
  },
  {
    title: '9. Kontakt',
    body: 'Spørgsmål til vilkårene kan rettes til support@forbrugeragenten.dk',
  },
]

export default function VilkaarPage() {
  const router = useRouter()

  return (
    <SafeAreaView style={styles.container}>
      <ContentContainer>
        <View style={styles.header}>
          <Pressable onPress={() => router.back()} style={styles.backButton}>
            <ArrowLeft size={20} color={colors.text.primary} />
          </Pressable>
          <Text style={styles.headerTitle}>Vilkår & Betingelser</Text>
        </View>

        <ScrollView contentContainerStyle={styles.content}>
          <Text style={styles.updated}>Sidst opdateret: 27. februar 2026</Text>

          {SECTIONS.map((section, i) => (
            <View key={i} style={styles.section}>
              <Text style={styles.sectionTitle}>{section.title}</Text>
              {section.title === '9. Kontakt' ? (
                <Text style={styles.sectionBody}>
                  Spørgsmål til vilkårene kan rettes til{' '}
                  <Text onPress={() => Linking.openURL('mailto:support@forbrugeragenten.dk')} style={{ color: colors.primary, textDecorationLine: 'underline' }}>
                    support@forbrugeragenten.dk
                  </Text>
                </Text>
              ) : (
                <Text style={styles.sectionBody}>{section.body}</Text>
              )}
            </View>
          ))}
        </ScrollView>
      </ContentContainer>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.surface,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: colors.background,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  backButton: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: borderRadius.sm,
    backgroundColor: colors.surface,
  },
  headerTitle: {
    ...typography.h2,
    color: colors.text.primary,
  },
  content: {
    padding: spacing.md,
    paddingBottom: spacing.xxl,
  },
  updated: {
    ...typography.small,
    color: colors.text.muted,
    marginBottom: spacing.lg,
  },
  section: {
    marginBottom: spacing.lg,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.text.primary,
    marginBottom: spacing.xs,
  },
  sectionBody: {
    ...typography.caption,
    color: colors.text.secondary,
    lineHeight: 22,
  },
})
